<template>
	<article class="checkout-complete p-5">
		<div>
			<h1>Tack för din beställning!</h1>
			<template v-if="order">
				<span v-if="order.shippingMethod.id === 4 /* Hämta i butik */">Vi kontaktar dig när din order finns att hämta.</span>
				<div class="panel p-5 mb-5" style="line-height: 1.4em; vertical-align: middle" v-else-if="order.shippingMethod.id !== 5 && ! order.isPrivateCustomer /* E-mail, privatkund */">
					<div class="checkbox m-0">
						<label style="font-weight: bold; font-size: 1.1em" @click.stop.prevent="wantsPhysicalWaybill = ! wantsPhysicalWaybill">
							<input type="checkbox" v-model="wantsPhysicalWaybill">
							{{ to('PHYSICAL_WAYBILL') }}
						</label>
					</div>
					<div>
						{{ to('WANT_PHYSICAL_WAYBILL') }}
					</div>
				</div>
			</template>
		</div>
		<div>
			<div v-if="order">
				<p>
					Ditt ordernummer är <b>{{ order.id }}</b>. Spara ordernumret och ange det om du kontaktar oss angående din order.
				</p>
				<p v-if="email">En orderbekräftelse skickas till <b>{{ email }}</b> inom kort.</p>
			</div>

			<div v-if="! isLoggedIn">
				<hr>
				<h3>
					<img :src="('/img/icons/medlemslappen.svg')" class="mr-3" style="height: 36px; margin-top: -8px;" alt="become-member"/>
					Spara din beställning och bli medlem!
				</h3>
				<div class="pb-3">
					Se status på dina beställningar, samla alla dina kvitton på din medlemsprofil, tjäna XP och få Achievements vilket i sin tur låser upp rabatter på produkter, frakt och fyndvaror, få prioriterad frakt m.m.
				</div>
				<div class="text-center pt-5 member-btn-wrap " v-if="! displayLoginInComp">
					<div v-if="registrationFormVisible" class="mx-auto" style="max-width: 400px">
						<register-form :email="email" :orderId="parseInt(orderId)" :secret="secret" />
					</div>
					<div v-else>
						<text-button
							text="Bli medlem"
							size="large"
							center
							width="stretch"
							@click="registrationFormVisible = true"
						/>
					</div>
				</div>
				<div class="text-center pb-5">
					<div v-if="! displayLoginInComp">
						Redan medlem? <a @click="login">Logga in</a> för att spara orden på ditt konto.</div>
					<div v-else class="mx-auto" style="max-width: 325px;">
						<login-form :orderId="parseInt(orderId)" :secret="secret" />
						<div class="mx-auto pb-5" style="max-width: 300px; margin-top: -10px;">
							<text-button
								text="Bli medlem"
								center
								@click="login"
							/>
							<router-link class="underline pull-right" :to="passwordResetRoute">Glömt lösenord?</router-link>
						</div>
					</div>
				</div>
				<hr>
			</div>

			<div v-if="$route.query.kco">
				<iframe :src="'/api/checkout/kco/confirmation/?snippet=true&orderId=' + $route.query.kco" style="width:100%; border: none" onload="this.style.height=this.contentDocument.body.scrollHeight +'px';" />
			</div>

			<div v-if="order">
				<div v-if="! order.hasPendingPayment">
					<b>Din betalning är under behandling.</b> Det kan dröja några minuter innan din betalning registreras.<br>
				</div>
				<div v-if="canAddProducts()" style="margin-bottom: 5px;">
					<h2>{{ to('EVERYTHING_YOU_NEED') }}</h2>
					<p>{{ to('ADD_MORE_PRODUCTS') }}</p>
					<div class="row">
						<product-list class="pt-3" :checkoutMode="true" analytics-category="Accessories" :products="tips"/>
						<div v-if="loading" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; background-color:rgba(20, 30, 50, 0.5); display: flex; justify-content: center; align-items: center; z-index: 9999">
							<div style="border: 2px solid rgb(76, 76, 76); border-radius: 2px; background-color: rgba(0, 0, 0, 0.71); padding: 15px; margin: 15px;">
								<loading-spinner class="mb-5"/>
								<p style="font-weight: 600; color: #FFFFFF; font-size: 22px; margin-bottom: 0px;">Uppdaterar din beställning..</p>
							</div>
						</div>
					</div>
				</div>
				<div class="prisjakt-voting-elements" id="prisjakt-container">
					<div
						class="checkout_rating_widget"
						data-shop-id="113"
						data-widget-id="6c08c7b4-e65b-47a3-ad57-20a966879c9c"
						data-market="SE"
					/>
				</div>
				<order :order="order" :secret="secret" noCancel showStatuses />
				<div v-if="selectedStore">
					<h2>Hitta till butiken</h2>
					Produkterna kommer att vara reserverade åt dig i vald butik. Ej uthämtade ordrar avbeställs automatiskt.
					<store-info-container class="mt-5" :store="selectedStore" />
				</div>
				<hr>
				<customer-survey :order="order" />
			</div>
			<img if="order" :src="affiliateTrackingLink" height="1" width="20" alt="order">
		</div>
	</article>
</template>

<script>
import waja from 'waja';
import mq from 'mediaQuery';
import store from 'datastore';
import { mapGetters } from 'vuex';
import bus from 'eventbus';
import alert from 'alert';
import { getStore, t } from 'datastore/i18n';
import md5 from 'adtractionHash';
import { trackImpression, testTransactionData } from 'gtm';
import format from 'date-fns/format';
import localSessionStorage from 'localSessionStorage';

export default {
	store,
	data () {
		return {
			user: null,
			snippet: '',
			orderId: null,
			order: null,
			email: '',
			mq,
			accessories: [],
			loading: false,
			registrationFormVisible: false,
			userExists: true,
			displayLoginInComp: false,
			purchaseEventSent: false,
			resizeObserver: null,
			iframeCounter: 0,
		};
	},
	beforeRouteEnter (to, frm, next) {
		if ( window.location !== window.parent.location ) {
			window.parent.location = window.location;
		} else {
			if (to.query.kco) {
				waja.post('checkout/kco/create')
					.data({
						'klarna_order_id' : to.query.kco,
						'region_code': 'se',
					}).on('success', res => {
						next(vm => {
							vm.orderId = res.data.orderId;
							vm.email = res.data.email;

							waja.get('order/' + res.data.orderId)
								.data({
									secret: to.query.kco,
								})
								.on('success', response => {
									vm.purchaseEventSent = response.data.order.purchaseEventSent;
									vm.order = response.data.order;
									vm.doAnalytics(vm.order);
								}).go();
						});
				}).go();
			}
			if (to.params.id) {
				let url = 'order/' + to.params.id;
				if (to.query && to.query.secret) {
					url += '?secret=' + to.query.secret;
				}
				waja.get(url)
					.on('success', res => {
						next(vm => {
							vm.order = res.data.order;
							vm.email = res.data.order.email;
							vm.orderId = vm.order.id;
							vm.purchaseEventSent = res.data.order.purchaseEventSent;
							vm.doAnalytics(vm.order);
						});
					}).go();
			}
		}
	},
	methods: {
		to: t.prefix('ORDER'),
		doAnalytics (order) {
			let orderSum = 0;
			let productIds = [];
			let productNames = [];
			let sectionTotals = {};
			let vat = 0;

			for (let i = 0; i < order.rows.length; i++) {
				const row = order.rows[i];
				const price = row.unitPrice - +row.unitVat.toFixed(2);
				const section = row.product.section;
				vat += +row.unitVat.toFixed(2);
				orderSum += price * row.quantity;
				productIds.push(row.product.id);
				productNames.push(row.product.name);

				/* Data for Adtraction */
				if (! sectionTotals[section.id]?.name) {
					const chars = {
						'å': 'a',
						'ä': 'a',
						'ö': 'o'
					};
					/** Turning string to lower case,
					** replacing åäö with a and o,
					** removing spaces and special characters */
					const sectionName = section.name.toLowerCase()
						.replace(/[åäö]/g, m => chars[m])
						.replace(/[^a-z0-9]()/gi,'');

					sectionTotals[section.id] = { name: sectionName };
				}

				if (! sectionTotals[section.id]?.sum) {
					sectionTotals[section.id] = {
						sum: price * row.quantity,
						...sectionTotals[section.id],
					};
				} else {
					sectionTotals[section.id].sum += price * row.quantity;
				}
			}

			let formattedAdtractionData = '';
			Object.values(sectionTotals).forEach(value => {
				let sum = value.sum;

				/* Makes sure all floats are two decimals */
				if (! Number.isInteger(sum)) {
					sum = parseFloat(sum).toFixed(2);
				}

				if (! formattedAdtractionData) {
					formattedAdtractionData = value.name + '_' + sum;
				} else {
					formattedAdtractionData += '-' + value.name + '_' + sum;
				}
			});

			// Adtraction affiliate reporting (Webhallen-account values from Adtraction)
			var ADT = window.ADT || {};
			ADT.Tag = ADT.Tag || {};
			ADT.Tag.t = 3;
			ADT.Tag.c = "SEK";
			ADT.Tag.tp = 1290132680;
			ADT.Tag.am = orderSum;
			ADT.Tag.ti = order.id;
			ADT.Tag.xd = this.email ? md5(this.email) : null;
			ADT.Tag.cpn = "";
			ADT.Tag.pc = formattedAdtractionData;
			if (window.ADT) {
				ADT.Tag.doEvent();
			}
			/** Check dates to make sure we are not tracking
			 * old orders on the wrong date
			 */
			const orderDate = format(new Date(order.orderDate * 1000), 'YYYY-MM-DD');
			const today = format(new Date(), 'YYYY-MM-DD');
			// Google Analytics
			if (! this.purchaseEventSent && today === orderDate) {
				const gtmProducts = order.rows.reduce((accumulator, row) => {
					let rowObject = {
						...row.product,
						qty: row.quantity,
						unitPrice: row.unitPrice - row.unitVat.toFixed(2),
					}

					if (row.product.id === 290553) {
						rowObject.brand = 'Webhallen'
						rowObject.categoryTree = 'Presentkort/Presentkort/Presentkort'
					}

					accumulator.push(rowObject);

					if (row.insuranceInfo && row.insuranceInfo.length) {
						row.insuranceInfo.forEach(insurance => {
							accumulator.push({
								...insurance,
								id: insurance.insurance.id,
								name: insurance.insurance.name,
								unitPrice: insurance.unitPrice,
								brand: insurance.provider === 1 ? 'Webhallen' : '',
								categoryTree: 'Tjänster/Tjänster/Försäkringar',
								qty: insurance.quantity,
							});
						});
					}

					return accumulator;
				}, []);

				const extraData = {
					event: 'client_transaction',
					coupon: true,
					orderId: order.id,
					totalSum: order.totalSum - vat,
					tax: vat + order.shippingMethod.vat,
					taxShipping: order.shippingMethod.vat,
					shipping: order.shippingMethod.price - order.shippingMethod.vat,
					paymentType: order.paymentMethod.name,
					shippingType: order.shippingMethod.name,
					coupon: order.discountCodes.length ? order.discountCodes.join('|') : null,
					hashEmail: order.hashEmail,
					hashPhone: order.hashPhone,
					numberOfOrders: order.numberOfOrders
				};
				testTransactionData(order.id);
				trackImpression(gtmProducts, 'confirmation', extraData);
				waja.post('purchase-event/' + order.id).go();
			}
		},
		removeProductFromOrder (product) {
			this.addProductToOrder(product, 0, 1);
		},
		addProductToOrder (product, amount, price) {
			// Check if the order amount is the same as in the order
			let orderRow = null;
			for (const row of this.order.rows) {
				if (product.id !== row.product.id) {
					continue;
				}
				orderRow = row;
				// If the quantity is unchanged or if this is a watcher callback from the quantityWatch abort.
				if (amount === row.quantity || (amount === 0 && row.deleted)) {
					bus.$emit('orderRowUpdated', product.id);
					return;
				}
				break;
			}

			if (! orderRow && amount === 0) {
				bus.$emit('orderRowUpdated', product.id);
				return;
			}

			if (amount === 0) {
				/* Set the deleted flag to be able to abort when this method is called again by the quantityWatch watcher
				in product-checkout-accessory-item.vue */
				orderRow.deleted = true;
			}

			this.loading = true;

			// Need to pass the secret
			// waja.patch('order/' + this.order.id) REMOVED FOR BRIQPAY, KEEP FOR BACKWARDS COMPABILITY
			waja.patch('payments/briqpay/order/' + this.session_id)
				.data({
					product: product.id,
					quantity: amount,
					unitPrice: price,
					pass: product.price && product.price.password ? product.price.password : null,
					secret: this.secret,
				})
				.on('success', res => {
					this.loading = false;
					if (! res.data.order) {
						alert('Det gick inte att uppdatera ordern');
						return;
					}
					bus.$emit('orderRowUpdated', product.id);
					this.order = res.data.order;
					alert('Din order är uppdaterad!');
				}).on('403', res => {
					this.loading = false;
					let errorMessage = 'Det gick inte att uppdatera ordern';
					res.json().then(json => {
						if (json.errorMessage) {
							errorMessage += ': ' + json.errorMessage;
						}
						alert(errorMessage);
					}).catch( function (reject) {
						alert(errorMessage);
					});
					bus.$emit('orderRowUpdated', product.id);
				}).go();
		},
		canAddProducts () {
			return false; // @TODO Change back when we can update an order to IFS
			if (this.order.paymentMethod.id !== 2) {
				return false;
			}
			if (! this.tips.length) {
				return false;
			}
			return true;
		},
		updateExtraData (key, value) {
			const data = {
				secret: this.secret,
				order: {},
			};
			data.order[key] = value;
			waja.patch('order/' + this.order.id)
				.data(data).on('success', res => {
					this.order = res.data.order;
					alert('Ditt val har sparats!');
				}).on('error', err => {
					alert('Något gick fel! Vänligen försök igen eller kontakta kundtjänst');
				}).go();
		},
		login () {
			this.displayLoginInComp = !this.displayLoginInComp;
			if (! this.displayLoginInComp && ! this.registrationFormVisible) {
				this.registrationFormVisible = true;
			} else if (this.displayLoginInComp) {
				this.registrationFormVisible = false;
			}
		},
		isNewMemberOfferAvailable ()  {
			if (! this.isLoggedIn) {
				const orderId = this.order ? this.order.id : this.orderId;
				waja.get('user/findemailorphone/' + orderId + '/' + this.secret)
					.on('success', res => {
						this.userExists = !! res.data.total;
					}).go();
			}
		},
		addPrisjaktScript () {
			if (document.getElementById('prisjakt-container')) {
				const script = document.createElement('script');
				script.setAttribute('src', 'https://cdn.pji.nu/b2b/widgets/checkout-rating/index.js');
				script.setAttribute('id', 'checkout-rating-script');
				script.defer = true;
				script.onload = () => {
					script.parentNode.removeChild(script);
				};
				document.head.appendChild(script);

				const link = document.createElement('link');
				link.setAttribute('rel', 'stylesheet');
				link.setAttribute('href', 'https://cdn.pji.nu/b2b/widgets/checkout-rating/index.css');
				link.setAttribute('id', 'prisjakt-css');
				document.head.appendChild(link);

				this.resizePrisjaktIframe();
			} else {
				setTimeout(() => {
					this.addPrisjaktScript();
				}, 1000);
			}
		},
		resizePrisjaktIframe () {
			let prisjaktIframe = document.getElementsByName('PJWidget-checkout-rating0')[0];
			if (prisjaktIframe) {
				prisjaktIframe.removeAttribute('style');
				this.resizeObserver = new ResizeObserver((entries, obs) => {
					prisjaktIframe.height = entries[0].contentRect.height;
					prisjaktIframe.width = entries[0].contentRect.width;
				});
				this.resizeObserver.observe(prisjaktIframe.contentWindow.document.body.firstChild);
			} else if (this.iframeCounter < 5) {
				this.iframeCounter++;
				setTimeout(() => {
					this.resizePrisjaktIframe();
				}, 500);
			}
		},
	},
	computed: {
		passwordResetRoute () {
			const route = {
				name: 'reset-password',
			};
			if (this.email) {
				route.query = {
					username: this.email,
				};
			}
			return this.$router.route(route);
		},
		wantsPhysicalWaybill: {
			get () {
				// (bool)(int) eftersom värdet är '0' / '1' (sträng)
				return !!~~this.order.extraData.wants_physical_waybill;
			},
			set (value) {
				this.updateExtraData('wantsPhysicalWaybill', value);
			},
		},
		wantsOrderSplit: {
			get () {
				return !!~~this.order.extraData.wants_order_split;
			},
			set (value) {
				this.updateExtraData('wantsOrderSplit', value);
			},
		},
		secret () {
			const q = this.$route.query || {};
			return q.secret || q.kco;
		},
		selectedStore () {
			const store = this.order.store ? getStore(this.order.store.id) : null;
			return store;
		},
		orderRows () {
			const orderRows = [];
			for (const row of this.order.rows) {
				const transformRow = {};
				transformRow.productId = row.product.id;
				transformRow.quantity = row.quantity;
				transformRow.unitPrice = row.unitPrice;
				orderRows.push(transformRow);
			}
			return orderRows;
		},
		affiliateTrackingLink () {
			if (! this.order) {
				return;
			}

			// Calculate the affiliate link
			let cjAffiliateTracking = '';

			for (const i in this.order.rows) {
				const row = this.order.rows[i];
				const sum = row.unitPrice - row.unitVat;
				cjAffiliateTracking += '&ITEM' + i + '=' + row.product.id + '&AMT' + i + '=' + sum + '&QTY' + i + '=' + row.quantity;
			}

			return 'https://www.emjcd.com/u?CID=1503565&TYPE=344707&OID=' + this.orderId + '' + cjAffiliateTracking + '&CURRENCY=SEK&METHOD=IMG&CJEVENT=' + this.order.cjEvent;
		},
		isMobile () {
			return this.mq.current <= this.mq.sm;
		},
		tips () {
			// Remove locked products from the product tips.
			return this.accessories.filter(function (element) {
				for (const row of this.rows) {
					if (row.locked && row.product.id === element.id) {
						return false;
					}
				}
				return true;
			}, this.order);
		},
		storeCreditIconImage () {
			return ('/api/dynimg/category/kampanjer/149848');
		},
		...mapGetters ({
			isLoggedIn: 'user/isLoggedIn',
		}),
	},
	destroyed () {
		bus.$off('addToOrder');
		bus.$off('removeFromOrder');
	},
	mounted () {
		bus.$on('addToOrder', this.addProductToOrder);
		bus.$on('removeFromOrder', this.removeProductFromOrder);

		const updatedVouchers = localSessionStorage.get('updatedVouchers');
		if (updatedVouchers) {
			localSessionStorage.remove('updatedVouchers');
		}

		this.addPrisjaktScript();

		if (this.$route.query.kco) {
			this.$store.dispatch('cart/clear', { product: null });
		} else {
			this.$store.dispatch('cart/refresh');
		}
	},
	beforeDestroy () {
		document.getElementById('prisjakt-css').remove();
	},
	watch: {
		accessories (to) {
			/* Set extraQuantity on accessories already in the order.
			extraQuantity is used to display the current number of this product already added to the order.
			*/
			to.map(function (element) {
				for (const row of this.rows) {
					if (! row.locked && row.product.id === element.id) {
						element.extraQuantity = row.quantity;
					}
				}
			}, this.order);
		},
		order (to) {
			this.isNewMemberOfferAvailable();
		},
	},
};
</script>
